import React, { FC, useState } from 'react';
import SectionTitle from '@src/components/SectionTitle';
import { DropdownInput } from '@src/components/Select/DropdownInput';
import { Option } from '@src/components/Select/interfaces/option.interface';
import { FundingProps } from './props';
import './styles.scss';

export const Funding: FC<FundingProps> = ({ data, defaultValue, isInvalid, onChange }) => {
  const [selectedValue, setSelectedValue] = useState<Option | undefined>(
    defaultValue
      ? {
          label: defaultValue.value,
          value: defaultValue.id,
        }
      : undefined,
  );

  const dataWithNoneOption = Array.isArray(data)
    ? [{ label: 'None', value: '' }, ...data.map(item => ({ label: item.value, value: item.id }))]
    : [{ label: 'None', value: '' }];

  return (
    <div className="fundings">
      <SectionTitle size="S" title="Total funding to date (in Euros)" />

      <DropdownInput
        isInvalid={isInvalid}
        onChange={option => {
          const selectedValue = data?.find(item => item.id === option?.value);

          if (option) {
            setSelectedValue(option);
          }

          if (selectedValue) {
            onChange?.(selectedValue);
          }
        }}
        options={dataWithNoneOption}
        placeholder="Please select"
        value={selectedValue}
      />
    </div>
  );
};
